export const productHeaderMapping: Record<string, string> = {
    'Product Code': 'code',
    'Product Name': 'name',
    Description: 'description',
    'Length (in cms)': 'length',
    'Width (in cms)': 'width',
    'Height (in cms)': 'height',
    'Weight (in kg)': 'weight',
    'Declared Value': 'declaredValue',
    'Declared Value Currency': 'declaredCurrency',
    'UN Number': 'dangerousGoodUnNumber',
    'Dangerous Goods Description': 'dangerousGoodName',
};

export const productHeaders = Object.keys(productHeaderMapping);
